import React, { useState, useEffect } from 'react';
import { Button, Typography, Paper, FormGroup, FormControlLabel, Checkbox, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

const AnnouncementCenterDetails = ({ row }) => {
    const isUserReg = 
        row.Title === "New user registration"
        || row.Title === "Approve new user registration" 
        || row.Title === "Review new user registration";
    const isReport = row.Title.includes("Report");
    const renderTextWithEmailLink = (text) => {
        const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
        const parts = text.split(emailRegex);
        return parts.map((part, index) => {
            if (emailRegex.test(part)) {
                return (
                    <Link key={index} to={`/userProfile/${row.PortalID}?email=${part}`} style={{ color: '#1976d2' }}>
                        {part}
                    </Link>
                );
            }
            return <span key={index}>{part}</span>;
        });
    };
    const renderReportLink = (text) => {

        const monthYearRegex = /for ([A-Za-z]+ \d{4})/;
        const match = text.match(monthYearRegex);

        if (match && match[1]) {
            const monthYear = match[1]; // e.g., 'January 2024'

            const startDate = dayjs(monthYear).toISOString();
            let linkUrl;
            if (text.includes("Supplier Pending Enrollment/Drop Report"))
                linkUrl = `/supplierPendingEnrollmentOrDrop?date=${startDate}`
            else if (text.includes("Supplier Active Customers Report"))
                linkUrl = `/SupplierActiveCustomer?date=${startDate}`;

            const parts = text.split(monthYear);

            return (
                <span>
                    {parts[0]}
                    <Link to={linkUrl}>{monthYear}</Link>
                    {parts[1]}
                </span>
            );
        }
        return text;
    };

    return (
        <>
            <Box className="userInformationcontainer">
                <Accordion component="div" defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        component="div"
                    >
                        <Typography component="h2" className='userInformation'>{dayjs(row.StartDate).format('MM/DD/YYYY hh:mm:ss A')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                                {isUserReg || isReport ? (
                                    <Typography 
                                        component="span"
                                        className='announcementcentertitile'
                                    >
                                        {isUserReg ? 
                                            renderTextWithEmailLink(row.Data) : 
                                            renderReportLink(row.Data)
                                        }
                                    </Typography>
                                ) : (
                                    <Typography 
                                        component="span"
                                        className='announcementcentertitile'
                                        dangerouslySetInnerHTML={{ __html: row.Data }}
                                    />
                                )}
                                
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </>

    );
};

export default AnnouncementCenterDetails;